import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Facebook, Mail } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_e6799e48-be90-493c-8434-b6147d09c3b6/artifacts/9k1prijt_image.png";
const FB = "https://www.facebook.com/ShipCostaRica/";
const EMAIL = "Greg@ShipCR.com";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-brand-cream border-t border-brand-navy/10 py-14">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="flex items-center gap-4">
            <img src={LOGO_URL} alt="Ship Costa Rica" className="h-14 w-14 rounded-xl object-cover ring-1 ring-brand-navy/10" />
            <div>
              <div className="font-heading font-black text-brand-navy text-lg tracking-tight">
                SHIP COSTA RICA
              </div>
              <div className="text-sm text-brand-navy/65 max-w-md">
                {t.footer.tagline}
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-6 text-sm font-semibold text-brand-navy/75">
            <a href="#how" data-testid="footer-link-how" className="hover:text-brand-red transition-colors">{t.footer.links.how}</a>
            <a href="#pricing" data-testid="footer-link-pricing" className="hover:text-brand-red transition-colors">{t.footer.links.pricing}</a>
            <a href="#why" data-testid="footer-link-why" className="hover:text-brand-red transition-colors">{t.footer.links.why}</a>
            <a href="#contact" data-testid="footer-link-contact" className="hover:text-brand-red transition-colors">{t.footer.links.contact}</a>
          </div>

          <div className="flex items-center gap-3">
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email"
              aria-label="Email"
              className="w-10 h-10 rounded-full bg-white border border-brand-navy/15 flex items-center justify-center text-brand-navy hover:bg-brand-red hover:text-white hover:border-brand-red transition-all"
            >
              <Mail size={16} />
            </a>
            <a
              href={FB}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              aria-label="Facebook"
              className="w-10 h-10 rounded-full bg-white border border-brand-navy/15 flex items-center justify-center text-brand-navy hover:bg-brand-red hover:text-white hover:border-brand-red transition-all"
            >
              <Facebook size={16} />
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-brand-navy/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-brand-navy/55">
          <div>© {year} Ship Costa Rica. {t.footer.rights}</div>
          <div className="font-medium">Miami, FL · San José, Costa Rica</div>
        </div>
        <div className="mt-4 text-center text-[11px] text-brand-navy/55 font-medium" data-testid="footer-credit">
          Website Created by{" "}
          <a
            href="https://www.GregMiceli.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand-navy/75 hover:text-brand-red font-semibold underline-offset-2 hover:underline transition-colors"
          >
            www.GregMiceli.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
